// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  background-color: #f2f2f2;
  color: #606060;
  box-shadow: 1px 1px #eaeaea;
}

.navbar-nav {
  display: flex;
  justify-content: space-around;
}

.navbar-item.active .nav-link {
  color: #4330ff !important;
}

.navbar-brand-mobile {
  display: none;
}

.navbar-item {
  position: relative;
}

.logout-button {
  position: relative;
  width: 60px;
}

.data-count[data-count]:after {
  position: absolute;
  top: 5%;
  content: attr(data-count);
  font-size: 0.5em;
  padding: 0.6em;
  border-radius: 999px;
  line-height: 0.75em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 2em;
  font-weight: bold;
}

.nav-link {
  color: #606060;
}

.debug-json {
  display: none;
}

.page-title-nav {
  background-color: #f2f2f2;
  border-top: 2px solid #c0c0c0;
}
.page-title-nav .back-button i {
  color: #4330ff;
  vertical-align: sub;
}
.page-title-nav .back-button h6 {
  color: #4330ff;
  display: inline-block;
}
.page-title-nav .page-title-name {
  text-align: center;
}
.page-title-nav .page-title-name h6 {
  margin-bottom: 0px;
  padding-top: 7px;
  padding-bottom: 7px;
}

@media only screen and (max-width: 992px) {
  .navbar-brand-mobile {
    display: block;
  }
  a.navbar-brand {
    display: none;
  }
  .navbar-item {
    width: 120px;
  }
}
@media only screen and (min-width: 992px) {
  .navbar-expand-lg .navbar-nav {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Layout/layout.scss","webpack://./src/app/variables.scss","webpack://./src/components/Layout/layout.css"],"names":[],"mappings":"AAEA;EACE,yBCMc;EDLd,cCUiB;EDTjB,2BAAA;AEDF;;AFIA;EACE,aAAA;EACA,6BAAA;AEDF;;AFKC;EACC,yBAAA;AEFF;;AFMA;EACE,aAAA;AEHF;;AFMA;EACE,kBAAA;AEHF;;AFMA;EACE,kBAAA;EACA,WAAA;AEHF;;AFMA;EACE,kBAAA;EACA,OAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AEHF;;AFMA;EACC,cClCkB;AC+BnB;;AFMA;EACC,aAAA;AEHD;;AFMA;EACE,yBC/Cc;EDgDd,6BAAA;AEHF;AFKI;EACE,cClCQ;EDmCR,mBAAA;AEHN;AFKI;EACE,cCtCQ;EDuCR,qBAAA;AEHN;AFME;EACE,kBAAA;AEJJ;AFKI;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AEHN;;AFQA;EACE;IACE,cAAA;EELF;EFOA;IACE,aAAA;EELF;EFOA;IACE,YAAA;EELF;AACF;AFQA;EACE;IACE,WAAA;EENF;AACF","sourcesContent":["@import '../../app/variables.scss';\n\nnav {\n  background-color: $lightest-gray;\n  color: $medium-dark-gray;\n  box-shadow: 1px 1px $light-gray;\n}\n\n.navbar-nav{\n  display: flex;\n  justify-content: space-around;\n}\n\n.navbar-item.active {\n\t.nav-link {\n\t\tcolor: $evanta-blue !important;\n\t}\n}\n\n.navbar-brand-mobile{\n  display: none;\n}\n\n.navbar-item {\n  position: relative;\n}\n\n.logout-button {\n  position: relative;\n  width: 60px;\n}\n\n.data-count[data-count]:after{\n  position:absolute;\n  top:5%;\n  content: attr(data-count);\n  font-size:.5em;\n  padding:.6em;\n  border-radius:999px;\n  line-height:.75em;\n  color: white;\n  background:rgba(255,0,0,.85);\n  text-align:center;\n  min-width:2em;\n  font-weight:bold;\n}\n\n.nav-link {\n\tcolor: $medium-dark-gray;\n}\n\n.debug-json{\n\tdisplay: none\n}\n\n.page-title-nav {\n  background-color: $lightest-gray;\n  border-top: 2px solid $medium-gray;\n  .back-button {\n    i {\n      color: $evanta-blue;\n      vertical-align: sub;\n    }\n    h6 {\n      color: $evanta-blue;\n      display: inline-block;\n    }\n  }\n  .page-title-name {\n    text-align: center;\n    h6 {\n      margin-bottom: 0px;\n      padding-top: 7px;\n      padding-bottom: 7px;\n    }\n  }\n}\n\n@media only screen and (max-width : 992px) {\n  .navbar-brand-mobile{\n    display: block;\n  }\n  a.navbar-brand{\n    display: none;\n  }\n  .navbar-item {\n    width: 120px;\n  }\n}\n\n@media only screen and (min-width : 992px) {\n  .navbar-expand-lg .navbar-nav {\n    width: 100%;\n  }\n}\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$light-base: #006AC7;\n$light-active: #264A82;\n$success-base: #00A76D;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002869;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n$solar-tertiary: #DE0A01;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n","nav {\n  background-color: #f2f2f2;\n  color: #606060;\n  box-shadow: 1px 1px #eaeaea;\n}\n\n.navbar-nav {\n  display: flex;\n  justify-content: space-around;\n}\n\n.navbar-item.active .nav-link {\n  color: #4330ff !important;\n}\n\n.navbar-brand-mobile {\n  display: none;\n}\n\n.navbar-item {\n  position: relative;\n}\n\n.logout-button {\n  position: relative;\n  width: 60px;\n}\n\n.data-count[data-count]:after {\n  position: absolute;\n  top: 5%;\n  content: attr(data-count);\n  font-size: 0.5em;\n  padding: 0.6em;\n  border-radius: 999px;\n  line-height: 0.75em;\n  color: white;\n  background: rgba(255, 0, 0, 0.85);\n  text-align: center;\n  min-width: 2em;\n  font-weight: bold;\n}\n\n.nav-link {\n  color: #606060;\n}\n\n.debug-json {\n  display: none;\n}\n\n.page-title-nav {\n  background-color: #f2f2f2;\n  border-top: 2px solid #c0c0c0;\n}\n.page-title-nav .back-button i {\n  color: #4330ff;\n  vertical-align: sub;\n}\n.page-title-nav .back-button h6 {\n  color: #4330ff;\n  display: inline-block;\n}\n.page-title-nav .page-title-name {\n  text-align: center;\n}\n.page-title-nav .page-title-name h6 {\n  margin-bottom: 0px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n}\n\n@media only screen and (max-width: 992px) {\n  .navbar-brand-mobile {\n    display: block;\n  }\n  a.navbar-brand {\n    display: none;\n  }\n  .navbar-item {\n    width: 120px;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .navbar-expand-lg .navbar-nav {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
